import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { DatePicker } from "antd";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import Table from "../../Components/TableTemplate/Table";
import {
  getRole,
  formatDateNoTime,
  numberFormat,
  dateFormat,
  refreshPage,
  toastStyle,
  numberWithCommas,
  getRestoLogin,
} from "../../Helpers/Utils/Common";
import ExportPDF from "../../Components/Export/ExportPDF";
import { DownloadTableExcel } from "react-export-table-to-excel";
import moment from "moment";
import imageCompression from "compressorjs";
import html2canvas from "html2canvas";
import toast from "react-hot-toast";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";

const { RangePicker } = DatePicker;

function SeniorDiscounts() {
  const [inactive, setInactive] = useState(true);
  const [report, setReport] = useState([]);
  const componentRef = useRef();
  const [showLoader, setShowLoader] = useState(false);
  const dateToday = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  });
  const [exportData, setExportData] = useState([]);
  const [overAllSales, setOverAllSales] = useState(0);
  const [totalDiscounted, setTotalDiscount] = useState(0);

  const headers = [
    "INVOICE NO.",
    "DATE ADDED",
    "ID NO.",
    "NAME",
    "GROSS SALES",
    "SALES DISCOUNT",
  ];

  async function fetchReport() {
    setShowLoader(true);
    const response = await UseGetRequest("reports/sc", filter, getRestoLogin());
    if (response.data) {
      const data = response.data.data.sales;
      setReport(data);
      var arr = [];
      response.data.data.sales.map((data) => {
        arr.push({
          ...data,
          payment_date: formatDateNoTime(data.payment_date),
        });
      });
      const exportInfo = data.map((info) => {
        return {
          trans_no: info.trans_no,
          date_added: info.payment_date,
          ids: info.senior_ids,
          names: info.senior_names,
          subtotal: info.subtotal,
          total_discount: info.total_discount,
        };
      });
      setOverAllSales(
        arr
          .map((data) => parseFloat(data.subtotal))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setTotalDiscount(
        arr
          .map((data) => parseFloat(data.total_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setExportData(exportInfo);
    } else {
      setReport([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  /** EXPORT */
  function handleToCSV() {
    return (
      <DownloadTableExcel
        filename="Senior Report Summary"
        sheet="users"
        currentTableRef={componentRef.current}
      >
        <button className=" category-new-export-btn">Export to CSV</button>
      </DownloadTableExcel>
    );
  }

  function handlePDF() {
    return (
      <ExportPDF
        name={"Senior Citizen Discount Sales"}
        data={exportData}
        report={"discount"}
        date={filter}
        header={headers}
      />
    );
  }

  const divId = useRef(null);

  const handleGeneratePrint = () => {
    if (divId.current) {
      const element = divId.current;

      element.style.width = "36%";
      // element.style.height = "100%"
      html2canvas(element, { scale: 1 }).then((canvas) => {
        canvas.toBlob((blob) => {
          new imageCompression(blob, {
            quality: 0.6,
            maxWidth: 2024,
            // maxHeight: 1024,
            success(compressedResult) {
              const reader = new FileReader();
              reader.readAsDataURL(compressedResult);
              reader.onloadend = () => {
                const compressedBase64 = reader.result;
                printBase64Data(compressedBase64);
                toast.success("Processing...", {
                  style: toastStyle(),
                });
              };
            },
          });
        }, "image/pngs");
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      getRestoLogin(),
      "Senior Discount"
    );
    if (response.data) {
      refreshPage();
    }
  }

  useEffect(() => {
    fetchReport();
  }, [filter]);

  const marginTop = "-800px";
  const marginRight = "60px";
  const marginBottom = "-1000px";
  const marginLeft = "45px";
  const getPageMargins = () => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;}`;
  };

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col xs={6} className="">
            <h1 className="page-title-menu"> SENIOR CITIZEN SALES REPORT</h1>
          </Col>
          <Col xs={6}>
            {report.length > 0 && (
              <Row>
                <Col>
                  <button
                    className="category-new-export-btn"
                    onClick={handleGeneratePrint}
                  >
                    PRINT
                  </button>
                </Col>
                <Col>{handleToCSV()}</Col>
                <Col>{handlePDF()}</Col>
              </Row>
            )}
          </Col>
        </Row>
        <hr />
        <div className="table-content">
          <div className="my-2 px-4 PO-filters d-flex">
            {getRole() !== "2" && (
              <>
                <Col xs={2} className="center">
                  FILTER BY DATE:
                </Col>
                <Col xs={4}>
                  <RangePicker
                    onChange={(e) => {
                      if (e) {
                        setFilter((prev) => ({
                          ...prev,
                          date_from: e[0].format("YYYY-MM-DD"),
                          date_to: e[1].format("YYYY-MM-DD"),
                        }));
                      } else {
                        setFilter((prev) => ({
                          ...prev,
                          date_from: dateToday,
                          date_to: dateToday,
                        }));
                      }
                    }}
                    placeholder={[dateToday, dateToday]}
                    className="w-100 h-100"
                  />
                </Col>
              </>
            )}
          </div>
          {/* <div className="my-2 px-4 PO-filters d-flex mb-0">
            <span className="me-4 align-middle mt-2 bold-font">
              <h5>
                TOTAL SALES: PHP{" "}
                {numberFormat(parseFloat(overAllSales).toFixed(2))}
              </h5>
            </span>
          </div> */}
          <Row>
            <Col xs={6} className="ps-4">
               <h5>
                  TOTAL SALES: PHP{" "}
                  {numberFormat(parseFloat(overAllSales).toFixed(2))}
                </h5>
            </Col>
            <Col xs={6} className="pe-4" align='right'>
              <h5>
                TOTAL SALES DISCOUNT: PHP{" "}
                {numberFormat(parseFloat(totalDiscounted).toFixed(2))}
              </h5>
            </Col>
          </Row>
          {/* TABLE */}
          <Table
            tableHeaders={headers}
            headerSelector={[
              "trans_no",
              "date_added",
              "ids",
              "names",
              "subtotal",
              "total_discount",
            ]}
            tableData={exportData}
            showLoader={showLoader}
          />
        </div>
        {/* 
        <div style={{ display: "none" }}>
          <PrintReportReceipts
            ref={componentRefSummary}
            name={"Senior Citizen Report"}
            data={exportData}
            filter={filter}
          />
        </div> */}
        <div style={{ display: "none" }}>
          <Row>
            <div className="row" ref={componentRef}>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_name}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_address}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {" "}
                  {window.company_vat_reg_tin}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_min}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_sn}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.company_ptu_no}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text">
                  {window.issued_date}
                </label>
              </div>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>SENIOR REPORTS</th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE FROM: {dateFormat(new Date(filter.date_from))}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE TO: {dateFormat(new Date(filter.date_to))}
                    </th>
                  </tr>
                  <tr>
                    <th>Invoice No.</th>
                    <th>DATE ADDED</th>
                    <th>ID No.</th>
                    <th>NAME</th>
                    <th>GROSS SALES</th>
                    <th>SALES DISCOUNT</th>
                  </tr>
                  {report.map((data) => {
                    return (
                      <tr>
                        <td>{data.trans_no} </td>
                        <td>{data.payment_date} </td>
                        <td>{data.senior_ids}</td>
                        <td>{data.senior_names} </td>
                        <td>
                          {numberFormat(parseFloat(data.subtotal).toFixed(2))}{" "}
                        </td>
                        <td>
                          {numberFormat(
                            parseFloat(data.total_discount).toFixed(2)
                          )}{" "}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      {" "}
                      {numberFormat(parseFloat(overAllSales).toFixed(2))}
                    </td>
                    <td>
                      {" "}
                      {numberFormat(parseFloat(totalDiscounted).toFixed(2))}
                    </td>{" "}
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </Row>
        </div>
      </div>
      <div ref={divId} style={{ position: "absolute", left: "-9999px" }}>
        <style>{getPageMargins()}</style>
        <div className="print-area single-width rounded p-4">
          <Row className="text-center print-text">{window.company_name}</Row>
          <Row className="text-center print-text">{window.company_address}</Row>
          <Row className="text-center print-text">
            {window.company_vat_reg_tin}
          </Row>
          <Row className="text-center print-text">{window.company_min}</Row>
          <Row className="text-center print-text">{window.company_sn}</Row>
          <Row className="text-center print-text">{window.company_ptu_no}</Row>
          <Row className="text-center print-text">
            {window.company_issued_date}
          </Row>
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td colSpan={12} className="left print-text">
                  <strong>SENIOR CITIZEN SALES REPORT</strong>
                </td>
              </tr>
              <tr>
                <td colSpan={12} className="left print-text">
                  {moment(filter.date_from).format("MMMM DD, YYYY")} -{" "}
                  {moment(filter.date_to).format("MMMM DD, YYYY")}
                </td>
              </tr>
              <tr>
                <td className="print-text">SI #</td>
                <td className="print-text align-right">GROSS SALES</td>
                <td className="print-text align-right">DISCOUNT</td>
              </tr>
              {exportData.map((row) => {
                return (
                  <tr>
                    <td className="print-text">{row.trans_no}</td>
                    <td className="print-text align-right">
                      {numberWithCommas(row.subtotal)}
                    </td>
                    <td className="print-text align-right">
                      {numberWithCommas(row.total_discount)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <label className="powered-label text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  );
}

export default SeniorDiscounts;
